"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var server_1 = require("./server");
var index_vue_1 = require("./index.vue");
var install = function (app) {
    index_vue_1.default.TUIServer = TUIConversation.server;
    app.component(TUIConversation.name, index_vue_1.default);
};
var plugin = function (TUICore) {
    TUIConversation.server = new server_1.default(TUICore);
    TUICore.component(TUIConversation.name, TUIConversation);
    return TUIConversation;
};
var TUIConversation = {
    name: 'TUIConversation',
    component: index_vue_1.default,
    server: server_1.default,
    install: install,
    plugin: plugin,
};
exports.default = TUIConversation;
